// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "babel-polyfill";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "@/store/index.js";
import echarts from "echarts";
import $getDict from "./utils/dict.config";
import delTabCheck from "@/static/delTabCheck";
import getListFn from "@/static/getList";
import req from "@/utils/request.config.js";
import mix from "./utils/heightSetter";
import { format } from "path";

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/index.css";

Vue.use(VXETable);
Vue.prototype.$echarts = echarts;
Vue.prototype.delTabCheck = delTabCheck; /*删除*/
Vue.prototype.getListFn = getListFn; /*查询*/
Vue.use(ElementUI);
Vue.use($getDict);
Vue.mixin(mix);

// req.get("/security/web/sysusersourcecode/listByUserName").then(res => {
//   sessionStorage.setItem(
//     "parkList",
//     JSON.stringify(res.data.data.sourceCodeAndName)
//   );
//   sessionStorage.setItem("activeSourceId", res.data.data.activeSourceId);
//   sessionStorage.setItem("activeSourceCode", res.data.data.activeSourceCode);
// });

router.beforeEach((to, from, next) => {
  sessionStorage.setItem("path", to.path);
  let i = store.state.aliveList.indexOf(to.name);
  if (i < 0) {
    store.state.aliveList.push(to.name);
  }
  let isRepet = false;
  for (let editableTab of store.state.editableTabs) {
    if (editableTab.url == to.path) {
      isRepet = true;
    }
  }
  if (!isRepet) {
    if (store.state.editableTabs.length < 10) {
      store.state.editableTabs.push({
        name: to.meta.name,
        url: to.path
      });
      sessionStorage.setItem("rightId", to.meta.rightId);
      next();
    } else {
      var f = from;
      console.log(to,from,next)
      if(to.path == '/login' || to.path=='/updatePassword'){
       next();
      }
      Vue.prototype
        .$confirm(
          "为了保证性能，请尽量不要打开超过十个页签，是否确定继续打开？",
          "提示",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: "打开",
            cancelButtonText: "打开并关闭其它",
            type: "warning"
          }
        )
        .then(() => {
          store.state.editableTabs.push({
            name: to.meta.name,
            url: to.path
          });
          sessionStorage.setItem("rightId", to.meta.rightId);
          next();
        })
        .catch(action => {
          if (action === "close") {
            sessionStorage.setItem("rightId", f.meta.rightId);
            next({ path: f.path });
          } else {
            store.state.editableTabs = [
              {
                name: "首页",
                url: "/homePage",
                menukey: "homePage"
              },
              {
                name: to.meta.name,
                url: to.path
              }
            ];
            store.state.aliveList = ["homePage", to.name];
            sessionStorage.setItem("rightId", to.meta.rightId);
            next();
          }
        });
    }
  } else {
    sessionStorage.setItem("rightId", to.meta.rightId);
    next();
  }
});

var ins = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

Vue.component("my-button", {
  inherit: false,
  template: `<el-button v-bind="$attrs" @click="handleClick"><slot></slot></el-button>`,
  data() {
    return {
      timeStamp: 0
    };
  },
  props: {
    timeGap: {
      type: Number,
      default: function() {
        return 2000;
      }
    }
  },
  methods: {
    handleClick() {
      let t = new Date();
      if (t - this.timeStamp > this.timeGap) {
        this.$emit("click");
      } else {
        this.$message.closeAll();
        this.$message.warning("操作太频繁了");
      }
      this.timeStamp = t;
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js